var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShareBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    stroke: "#000",
    strokeWidth: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.446 3.304v7.81h1.061v-7.81l1.13 1.126.751-.747-2.036-2.028a.53.53 0 0 0-.75 0l-2.038 2.03.75.747 1.132-1.128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.604 6.483a2.88 2.88 0 0 0-2.045-.845h-.01v1.057h.01c1.01 0 1.83.818 1.83 1.823v7.005a1.828 1.828 0 0 1-1.83 1.823H4.393c-1.01 0-1.83-.818-1.83-1.823V8.52c0-1.007.821-1.823 1.83-1.823h.01V5.64h-.01c-.773 0-1.499.3-2.045.844A2.857 2.857 0 0 0 1.5 8.522v7.005c0 .77.301 1.493.848 2.037a2.88 2.88 0 0 0 2.045.845h9.166c.773 0 1.499-.3 2.045-.845a2.857 2.857 0 0 0 .848-2.037V8.52a2.86 2.86 0 0 0-.848-2.037z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareBox);
export default __webpack_public_path__ + "static/media/ic_share_box.a5b9171514c2d56e99150193c2999cc5.svg";
export { ForwardRef as ReactComponent };